import { Addon, AddonType } from 'editor/src/store/editorModules/addons/types';

const getAddonURL = (addon: Addon) => (addon.type === AddonType.ADDON_CATEGORY ? undefined : addon.preview);

export default getAddonURL;
